/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const Point = require('../../geometry/Point');
const HeaderNode = require('./HeaderNode');
const { ColumnHeaderModel, RowHeaderModel} = require('./HeaderModel');

const HEIGHT = 500;
const IF_SECTION_DEFS = { size: 700, level: 0, visible: true };
const COMMENT_SECTION_DEFS = { size: 0, level: 0, visible: false };

/**
 * @class ColumnHeaderNode
 * @extends Node
 * @constructor
 */
module.exports = class ColumnHeaderNode extends HeaderNode {
	constructor() {
		super();

		this._data = new ColumnHeaderModel();
	}

	newInstance() {
		return new ColumnHeaderNode();
	}

	getItemType() {
		return 'columnheadernode';
	}

	_assignName(id) {
		this.setName(`ColumnHeader${id}`);
	}

	getSectionData() {
		return this._data;
	}

	getInternalSize() {
		return new Point(this.getSectionsSize(), this.getInternalHeight());
	}

	getInternalHeight() {
		if (this.isItemVisible() === false) {
			return 0;
		}

		return ColumnHeaderNode.HEIGHT + this.getMaxLevel() * 600;
	}

	static get HEIGHT() {
		return HEIGHT;
	}
};
